// Header.tsx
import Image from "next/image"
import Link from "next/link"
import { getSettings } from "@/core/lib/api/main/setting"
import { getMainMenu } from "@/core/lib/api/main/menu-api"

import HeaderNavAction from "./HeaderNavAction"
import HeaderNavToggle from "./HeaderNavToggle"
import HeaderNavMenu from "./HeaderNavMenu"
import Sidebar from "./Sidebar"
import HeaderShell from "./HeaderShell"
import { BUSINESS_NAME } from '@/core/config/business';

export default async function Header() {
  const [setting, mainMenu] = await Promise.all([
    getSettings(),
    getMainMenu(),
  ])

  if (!setting) {
    return <HeaderSkeleton />
  }

  return (
    <>
      <HeaderShell>
        <div className="flex items-center gap-5 py-2 lg:gap-8 h-full">
          <HeaderNavToggle />

          {/* لوگو دسکتاپ */}
          <Link
            href="/"
            className="hidden self-stretch relative h-full w-20 lg:block"
          >
            {setting?.logo_desktop &&
              (setting.logo_desktop.startsWith('http') || setting.logo_desktop.startsWith('/')) ? (
              <Image
                src={setting.logo_desktop}
                alt={setting.site_title || "Logo"}
                fill
                className="object-contain transition-all duration-500"
                priority
              // onError={(e) => {
              //   e.currentTarget.style.display = 'none';
              // }}
              />
            ) : (
              <span className="flex items-center justify-center h-full text-lg font-bold">
                {setting?.site_title || "Logo"}
              </span>
            )}
          </Link>


          <HeaderNavMenu mainMenu={mainMenu} />
        </div>

        {/* لوگو موبایل */}
        <Link
          href="/"
          className={`lg:hidden absolute left-1/2 -translate-x-1/2 h-full flex items-center justify-center ${BUSINESS_NAME === "vanda" ? "w-13" : "w-20"
            }`}
        >
          {setting?.logo_desktop &&
            (setting.logo_desktop.startsWith('http') || setting.logo_desktop.startsWith('/')) ? (
            <Image
              src={setting.logo_desktop}
              alt={setting.site_title || "Logo"}
              fill
              className="object-contain transition-all duration-500"
              priority
            // onError={(e) => {
            //   e.currentTarget.style.display = 'none';
            // }}
            />
          ) : (
            <span className="flex items-center justify-center h-full text-lg font-bold">
              {setting?.site_title || "Logo"}
            </span>
          )}
        </Link>

        <HeaderNavAction />
      </HeaderShell>

      <Sidebar mainItems={mainMenu} />
    </>
  )
}

function HeaderSkeleton() {
  return (
    <header className="sticky top-0 z-50 h-20 bg-primary-0/95 backdrop-blur-sm flex items-center justify-between px-4 sm:px-6 lg:px-12 border-b border-transparent">
      <div className="flex items-center gap-8">
        <div className="h-14 w-36 bg-primary-100/50 rounded-lg animate-pulse" />
        <div className="hidden lg:flex gap-6">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="h-4 w-20 bg-primary-100/50 rounded animate-pulse" />
          ))}
        </div>
      </div>
      <div className="h-10 w-10 bg-primary-100/50 rounded-full animate-pulse" />
    </header>
  )
}
